// src/components/dashboard/UpgradeModal.tsx
// ✅ MODAL GRAIA - SEM EMOJIS

import React from 'react';
import { Lock, ShoppingCart, X } from 'lucide-react';
import './UpgradeModal.css';

interface UpgradeModalProps {
    isOpen: boolean;
    onClose: () => void;
    entityType: 'cycle' | 'deck';
    entityName: string;
    entityId: string;
    cycleName?: string; // Para quando for deck
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({
    isOpen,
    onClose,
    entityType,
    entityName,
    entityId,
    cycleName
}) => {

    if (!isOpen) return null;

    const handleNavigateToMarketplace = () => {
        // ✅ Abrir em nova aba
        window.open('/marketplace', '_blank');
        onClose();
    };

    return (
        <div className="graia-modal-overlay" onClick={onClose}>
            <div className="graia-modal" onClick={(e) => e.stopPropagation()}>
                <button className="graia-modal-close" onClick={onClose}>
                    <X size={20} />
                </button>

                <div className="graia-modal-icon">
                    <Lock size={48} strokeWidth={1.5} />
                </div>

                <h2 className="graia-modal-title">
                    {entityType === 'cycle' ? 'Campo Bloqueado' : 'Deck Bloqueado'}
                </h2>

                <p className="graia-modal-description">
                    {entityType === 'cycle' ? (
                        <>
                            O campo de estudo <strong>{entityName}</strong> não está disponível no seu plano atual.
                        </>
                    ) : (
                        <>
                            O deck <strong>{entityName}</strong>
                            {cycleName && <> do campo <strong>{cycleName}</strong></>} não está disponível no seu plano atual.
                        </>
                    )}
                </p>

                <div className="graia-modal-actions">
                    <button
                        className="graia-btn-primary"
                        onClick={handleNavigateToMarketplace}
                    >
                        <ShoppingCart size={18} />
                        Ver no Catálogo
                    </button>

                    <button
                        className="graia-btn-secondary"
                        onClick={onClose}
                    >
                        Voltar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeModal;